module.exports = __webpack_public_path__ + "img/close.6e1133dc.svg";